const MEDIA_MESSAGE_TYPES = new Set(['m.image', 'm.video', 'm.audio', 'm.file']);
const MATRIX_MENTION_ANCHOR_REGEX = /<a\s+[^>]*href=["']https:\/\/matrix\.to\/#\/[^"']+["'][^>]*>/i;

const normalizeText = (value: unknown): string | null => {
    if (typeof value !== 'string') {
        return null;
    }

    const trimmed = value.trim();
    return trimmed.length > 0 ? trimmed : null;
};

export const isMediaMessageType = (msgType?: string | null): boolean => MEDIA_MESSAGE_TYPES.has(msgType || '');

export const getMediaCaption = (content: Record<string, unknown>): string | null => {
    const modernCaption =
        normalizeText((content['org.matrix.msc1767.caption'] as { body?: unknown } | undefined)?.body) ||
        normalizeText(content['org.matrix.msc1767.text']) ||
        normalizeText(
            typeof content['m.caption'] === 'string'
                ? content['m.caption']
                : (content['m.caption'] as { body?: unknown } | undefined)?.body
        );

    if (modernCaption) {
        return modernCaption;
    }

    const body = normalizeText(content.body);
    const filename = normalizeText(content.filename);

    if (!body) {
        return null;
    }

    if (!filename) {
        return null;
    }

    return body !== filename ? body : null;
};

/**
 * Returns the HTML version of a media caption when one is available.
 *
 * Older MobileCh3 versions placed Matrix mention anchors directly in `body`
 * without the Matrix `format`/`formatted_body` fields. Keep that narrow legacy
 * shape renderable while treating every other caption body as plain text.
 */
export const getMediaFormattedCaption = (content: Record<string, unknown>): string | null => {
    const caption = getMediaCaption(content);
    if (!caption) {
        return null;
    }

    const formattedBody = normalizeText(content.formatted_body);
    if (content.format === 'org.matrix.custom.html' && formattedBody) {
        return formattedBody;
    }

    if (MATRIX_MENTION_ANCHOR_REGEX.test(caption)) {
        return caption;
    }

    return null;
};
